// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  box-sizing: border-box;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.container {
  /*max-width: 1200px;*/
  margin: 0 auto;
}

header {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.message-row {
  align-items: center;
  border-bottom: 1px solid var(--ion-color-medium);
  padding: 10px 0;
}

.avatar-title-section ion-item {
  --padding-start: 0;
  display: flex;
  align-items: center;
}

.break-word {
  word-break: break-word; /* for older support */
  overflow-wrap: break-word; /* standard */
  white-space: normal; /* ensure it wraps */
}

.gradient-card {
  background: linear-gradient(135deg, #ff7e5f, #feb47b); /* Example of a gentle gradient */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Optional: add some shadow for better aesthetics */
  border-radius: 10px; /* Optional: smooth corners */
  color: white; /* Text color for readability */
}

.avatar {
  min-width: 20px;
  min-height: 20px;
  width: 20px;
  height: 20px;
}

.back_avatar {
  top: -77px;
  position: relative;
  z-index: -10;
}

.timestamp {
  color: var(--ion-color-medium);
  font-size: 0.9rem;
}

/* Ensure button stays at the end on large screens */
.action-section {
  display: flex;
  justify-content: flex-end;
}

swiper-container {
  display: block;
  width: 100%;
}

swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-title {
  background: rgba(255, 255, 255, 0.1); /* transparent white */
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px); /* optional: glassmorphism effect */
  padding: 16px;
  border-radius: 12px;
  margin: 16px;
  text-align: center;
}

.tagged-item {
  position: relative;
  overflow: visible; /* allow the tag to "stick out" */
}

.item-tag {
  position: absolute;
  top: -2px;
  left: 2px;
  background: var(--ion-color-secondary); /* red-ish Ion color */
  color: white;
  font-size: 16px;
  padding: 2px 6px;
  border-radius: 4px;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

header {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.logo {
  font-weight: 800;
  font-size: 20px;
  color: var(--accent);
}

.sub {
  color: var(--muted);
  font-size: 13px;
}

/* Arrange title and logo on the same row while keeping subtitle below */
header > div:first-child {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; /* allows subtitle to drop to next line */
}

/* force subtitle to new line in the flex container above */
header > div:first-child .sub {
  flex-basis: 100%;
}

/* header logo image */
.header-logo {
  height: 74px;
  width: auto;
  display: block;
  border-radius: 10px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35), inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

/* notifications */
.notif-btn {
  position: relative;
  border: none;
  background: var(--glass);
  color: #e6eef6;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(2, 6, 23, 0.5), inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.notif-btn:hover {
  background: rgba(255, 255, 255, 0.06);
}

.notif-btn svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.notif-badge {
  position: absolute;
  top: -6px;
  left: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: var(--danger);
  color: #fff;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 700;
  display: none;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.5);
}

.notif-badge.show {
  display: inline-flex;
}

.notif-popup {
  position: absolute;
  top: calc(100% + 8px);
  /* In RTL, anchor to left of the container that sits on the left side */
  left: 0;
  width: 300px;
  background: linear-gradient(180deg, rgba(30, 20, 20, 0.99), rgba(14, 2, 2, 0.99));
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 10px;
  z-index: 991000;
}

.notif-popup header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.notif-popup h4 {
  margin: 0;
  font-size: 14px;
}

.notif-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 260px;
  overflow: auto;
  background: black;
}

.notif-item {
  padding: 8px 6px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.15);
  margin-bottom: 6px;
  display: flex;
  align-items: start;
  gap: 8px;
}

.notif-item.unread {
  background: rgba(6, 182, 212, 0.12);
}

.notif-item .meta {
  font-size: 12px;
  color: var(--muted);
}

.notif-actions {
  display: flex;
  gap: 8px;
}

.btn-link {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-size: 12px;
}

.btn-link:hover {
  text-decoration: underline;
}

/* side list (sidebar) */
.side_list {
  position: fixed;
  top: 24px;
  bottom: 24px;
  left: 24px; /* sidebar on the right for RTL */
  width: 300px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 12px;
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.7), inset 0 0 0 1px rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10;
}

.side_list h4 {
  margin: 0 0 10px;
  font-size: 14px;
  color: var(--muted);
  font-weight: 700;
}

.side_list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: auto;
}

.side_list li {
  margin: 0;
}

.side_list .item {
  width: 100%;
  text-align: right;
  border: none;
  background: transparent;
  color: #e6eef6;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.side_list .item .num {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.06);
  color: #b6c2d9;
  font-weight: 800;
  font-size: 12px;
}

.side_list .item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.side_list .item:focus {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.side_list .item.active {
  background: rgba(6, 182, 212, 0.16);
  box-shadow: inset 0 0 0 1px rgba(6, 182, 212, 0.35);
}

/* push main content so it doesn't go under the sidebar */
.container {
  margin-inline-end: 348px;
}

/* responsive: stack the side list on top on small screens */
@media (max-width: 1024px) {
  .side_list {
    position: static;
    width: auto;
    height: auto;
    right: auto;
    bottom: auto;
  }
  .container {
    margin-inline-start: 0;
  }
}
/* grid */
.grid {
  display: grid;
  /*grid-template-columns:repeat(12, 1fr);*/
  gap: 16px;
}

.card {
  background: var(--card);
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(2, 6, 23, 0.6);
}

/* top metrics */
.metrics {
  color: white;
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.metric {
  padding: 14px;
  border-radius: 10px;
  background: var(--card);
}

.metric h3 {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}

.metric .value {
  font-size: 22px;
  font-weight: 700;
  margin-top: 8px;
}

.metric .subval {
  font-size: 13px;
  color: var(--muted);
  margin-top: 6px;
}

/* main layout */
.left {
  grid-column: 1/span 7;
}

.right {
  grid-column: 8/span 5;
}

/* tables and lists */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

th, td {
  padding: 8px;
  text-align: right;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

th {
  color: var(--muted);
  font-weight: 600;
  font-size: 12px;
}

.priority-list li {
  background: var(--glass);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chip {
  padding: 6px 8px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.03);
}

/* responsive */
@media (max-width: 900px) {
  .metrics {
    grid-template-columns: repeat(2, 1fr);
  }
  .left {
    grid-column: 1/-1;
  }
  .right {
    grid-column: 1/-1;
  }
  .grid {
    grid-auto-rows: minmax(80px, auto);
  }
}
/* small helpers */
.muted {
  color: var(--muted);
  font-size: 13px;
}

.progress {
  height: 8px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 999px;
  overflow: hidden;
}

.progress > i {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, var(--accent), #7c3aed);
}

.green {
  color: var(--success);
}

.red {
  color: var(--danger);
}

.btn {
  background: var(--accent);
  color: #021022;
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.small {
  font-size: 12px;
}

.delta {
  font-size: 12px;
  margin-inline-start: 6px;
}

/* סטייל לסטריפ קוביות סטטוס */
.status-strip {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  flex-wrap: nowrap; /* single row, side to side */
  width: 100%;
}

.status-box {
  flex: 1 1 0; /* each box grows equally to fill the row */
  color: white;
  padding: 1rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

* {
  box-sizing: border-box;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.container {
  /*max-width: 1200px;*/
  margin: 0 auto;
}

header {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
}

.card.metric {
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: right;
  direction: rtl;
}

.card.metric .value {
  font-size: 1.4em;
  font-weight: bold;
  margin-bottom: 5px;
}

.subval {
  font-size: 0.95em;
  color: #555;
  margin-top: 4px;
  color: #fff;
}

.delta {
  font-weight: bold;
  margin-right: 6px;
}

.delta.up {
  color: #16a34a; /* ירוק */
}

.delta.down {
  color: #dc2626; /* אדום */
}

.progress {
  background: #eee;
  height: 8px;
  border-radius: 10px;
  overflow: hidden;
}

.progress i {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #15803d);
}

/* סטייל לסטריפ קוביות סטטוס */
/* סטייל לסטריפ קוביות סטטוס */
/* סטייל לסטריפ קוביות סטטוס */
/* סטייל לסטריפ קוביות סטטוס */
/* סטייל לסטריפ קוביות סטטוס */
.status-strip {
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap; /* single row, side to side */
  width: 100%;
}

.status-box {
  flex: 1 1 0; /* each box grows equally to fill the row */
  color: white;
  padding: 1rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.status-box h3 {
  margin: 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.status-box h3 ion-icon {
  font-size: 1.2rem;
}

.status-box span {
  display: block;
  font-size: 1.6em;
  margin-top: 5px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/chat/onechat-option/onechat-option.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,sBAAA;EACA,yFAAA;AAEF;;AACA;EACE,qBAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gDAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,sBAAA,EAAA,sBAAA;EACA,yBAAA,EAAA,aAAA;EACA,mBAAA,EAAA,oBAAA;AAEF;;AACA;EACE,qDAAA,EAAA,iCAAA;EACA,wCAAA,EAAA,oDAAA;EACA,mBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,+BAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AAEF;;AACA;EACE,8BAAA;EACA,iBAAA;AAEF;;AACA,oDAAA;AACA;EACE,aAAA;EACA,yBAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,oCAAA,EAAA,sBAAA;EACA,kCAAA;UAAA,0BAAA,EAAA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAEF;;AAEA;EACE,kBAAA;EACA,iBAAA,EAAA,iCAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,sCAAA,EAAA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;AACF;;AAEA,wEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA,EAAA,yCAAA;AACF;;AAEA,2DAAA;AACA;EACE,gBAAA;AACF;;AAEA,sBAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,qFAAA;EACA,kCAAA;UAAA,0BAAA;AACF;;AAEA,kBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qFAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,uEAAA;EACA,OAAA;EACA,YAAA;EACA,iFAAA;EACA,mBAAA;EACA,2CAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA,wBAAA;AACA;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA,EAAA,iCAAA;EACA,YAAA;EACA,yFAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,sFAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,mCAAA;EACA,mDAAA;AACF;;AAEA,yDAAA;AACA;EACE,wBAAA;AACF;;AAEA,4DAAA;AACA;EACE;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;EACF;EAEA;IACE,sBAAA;EAAF;AACF;AAGA,SAAA;AACA;EACE,aAAA;EACA,yCAAA;EACA,SAAA;AADF;;AAIA;EAEE,uBAAA;EAEA,mBAAA;EACA,0CAAA;AAHF;;AAMA,gBAAA;AACA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,SAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA,gBAAA;AACA;EACE,qBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA,qBAAA;AACA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAHF;;AAMA;EACE,YAAA;EACA,iBAAA;EACA,kDAAA;AAHF;;AAMA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,qCAAA;AAHF;;AAMA,eAAA;AACA;EACE;IACE,qCAAA;EAHF;EAMA;IACE,iBAAA;EAJF;EAOA;IACE,iBAAA;EALF;EAQA;IACE,kCAAA;EANF;AACF;AASA,kBAAA;AACA;EACE,mBAAA;EACA,eAAA;AAPF;;AAUA;EACE,WAAA;EACA,qCAAA;EACA,oBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,cAAA;EACA,YAAA;EACA,0DAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,oBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,eAAA;EACA,wBAAA;AAPF;;AAUA,8BAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA,EAAA,6BAAA;EACA,WAAA;AAPF;;AAUA;EACE,WAAA,EAAA,2CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAPF;;AAUA;EACE,sBAAA;EACA,yFAAA;AAPF;;AAUA;EACE,qBAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAPF;;AAmBA;EACE,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,iBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,cAAA,EAAA,SAAA;AAhBF;;AAmBA;EACE,cAAA,EAAA,SAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,YAAA;EACA,oDAAA;AAhBF;;AAmBA,8BAAA;AACA,8BAAA;AACA,8BAAA;AACA,8BAAA;AACA,8BAAA;AACA;EACE,aAAA;EACA,SAAA;EAEA,iBAAA,EAAA,6BAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,WAAA,EAAA,2CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAjBF","sourcesContent":["* {\n  box-sizing: border-box;\n  font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial\n}\n\n.container {\n  /*max-width: 1200px;*/\n  margin: 0 auto;\n}\n\nheader {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 18px\n}\n\n.message-row {\n  align-items: center;\n  border-bottom: 1px solid var(--ion-color-medium);\n  padding: 10px 0;\n}\n\n.avatar-title-section ion-item {\n  --padding-start: 0;\n  display: flex;\n  align-items: center;\n}\n\n.break-word {\n  word-break: break-word; /* for older support */\n  overflow-wrap: break-word; /* standard */\n  white-space: normal; /* ensure it wraps */\n}\n\n.gradient-card {\n  background: linear-gradient(135deg, #ff7e5f, #feb47b); /* Example of a gentle gradient */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Optional: add some shadow for better aesthetics */\n  border-radius: 10px; /* Optional: smooth corners */\n  color: white; /* Text color for readability */\n}\n\n.avatar {\n  min-width: 20px;\n  min-height: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.back_avatar {\n  top: -77px;\n  position: relative;\n  z-index: -10;\n}\n\n.timestamp {\n  color: var(--ion-color-medium);\n  font-size: 0.9rem;\n}\n\n/* Ensure button stays at the end on large screens */\n.action-section {\n  display: flex;\n  justify-content: flex-end;\n}\n\nswiper-container {\n  display: block;\n  width: 100%;\n}\n\nswiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.section-title {\n  background: rgba(255, 255, 255, 0.1); /* transparent white */\n  backdrop-filter: blur(6px); /* optional: glassmorphism effect */\n  padding: 16px;\n  border-radius: 12px;\n  margin: 16px;\n  text-align: center;\n}\n\n\n.tagged-item {\n  position: relative;\n  overflow: visible; /* allow the tag to \"stick out\" */\n}\n\n.item-tag {\n  position: absolute;\n  top: -2px;\n  left: 2px;\n  background: var(--ion-color-secondary); /* red-ish Ion color */\n  color: white;\n  font-size: 16px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  z-index: 10;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\nheader {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 18px\n}\n\n.logo {\n  font-weight: 800;\n  font-size: 20px;\n  color: var(--accent)\n}\n\n.sub {\n  color: var(--muted);\n  font-size: 13px\n}\n\n/* Arrange title and logo on the same row while keeping subtitle below */\nheader > div:first-child {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap; /* allows subtitle to drop to next line */\n}\n\n/* force subtitle to new line in the flex container above */\nheader > div:first-child .sub {\n  flex-basis: 100%;\n}\n\n/* header logo image */\n.header-logo {\n  height: 74px;\n  width: auto;\n  display: block;\n  border-radius: 10px;\n  padding: 6px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35), inset 0 0 0 1px rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(2px);\n}\n\n/* notifications */\n.notif-btn {\n  position: relative;\n  border: none;\n  background: var(--glass);\n  color: #e6eef6;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 12px rgba(2, 6, 23, 0.5), inset 0 0 0 1px rgba(255, 255, 255, 0.06);\n}\n\n.notif-btn:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.notif-btn svg {\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n}\n\n.notif-badge {\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  background: var(--danger);\n  color: #fff;\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 700;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.5);\n}\n\n.notif-badge.show {\n  display: inline-flex;\n}\n\n.notif-popup {\n  position: absolute;\n  top: calc(100% + 8px);\n  /* In RTL, anchor to left of the container that sits on the left side */\n  left: 0;\n  width: 300px;\n  background: linear-gradient(180deg, rgba(30, 20, 20, 0.99), rgba(14, 2, 2, 0.99));\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 10px;\n  z-index: 991000;\n}\n\n.notif-popup header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.notif-popup h4 {\n  margin: 0;\n  font-size: 14px;\n}\n\n.notif-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 260px;\n  overflow: auto;\n  background: black;\n}\n\n.notif-item {\n  padding: 8px 6px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.15);\n  margin-bottom: 6px;\n  display: flex;\n  align-items: start;\n  gap: 8px;\n}\n\n.notif-item.unread {\n  background: rgba(6, 182, 212, 0.12);\n}\n\n.notif-item .meta {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.notif-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n}\n\n/* side list (sidebar) */\n.side_list {\n  position: fixed;\n  top: 24px;\n  bottom: 24px;\n  left: 24px; /* sidebar on the right for RTL */\n  width: 300px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  padding: 12px;\n  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.7), inset 0 0 0 1px rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(6px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 10;\n}\n\n.side_list h4 {\n  margin: 0 0 10px;\n  font-size: 14px;\n  color: var(--muted);\n  font-weight: 700;\n}\n\n.side_list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n}\n\n.side_list li {\n  margin: 0;\n}\n\n.side_list .item {\n  width: 100%;\n  text-align: right;\n  border: none;\n  background: transparent;\n  color: #e6eef6;\n  padding: 10px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.side_list .item .num {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #b6c2d9;\n  font-weight: 800;\n  font-size: 12px;\n}\n\n.side_list .item:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.side_list .item:focus {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n.side_list .item.active {\n  background: rgba(6, 182, 212, 0.16);\n  box-shadow: inset 0 0 0 1px rgba(6, 182, 212, 0.35);\n}\n\n/* push main content so it doesn't go under the sidebar */\n.container {\n  margin-inline-end: 348px;\n}\n\n/* responsive: stack the side list on top on small screens */\n@media (max-width: 1024px) {\n  .side_list {\n    position: static;\n    width: auto;\n    height: auto;\n    right: auto;\n    bottom: auto;\n  }\n\n  .container {\n    margin-inline-start: 0;\n  }\n}\n\n/* grid */\n.grid {\n  display: grid;\n  /*grid-template-columns:repeat(12, 1fr);*/\n  gap: 16px\n}\n\n.card {\n  //background: linear-gradient(180deg, rgb(41 41 41 / 0.2%), transparent);\n  background: var(--card);\n  //padding: 16px;\n  border-radius: 12px;\n  box-shadow: 0 4px 18px rgba(2, 6, 23, 0.6);\n}\n\n/* top metrics */\n.metrics {\n  color: white;\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns:repeat(4, 1fr);\n  gap: 12px\n}\n\n.metric {\n  padding: 14px;\n  border-radius: 10px;\n  background: var(--card);\n}\n\n.metric h3 {\n  margin: 0;\n  font-size: 13px;\n  color: var(--muted)\n}\n\n.metric .value {\n  font-size: 22px;\n  font-weight: 700;\n  margin-top: 8px\n}\n\n.metric .subval {\n  font-size: 13px;\n  color: var(--muted);\n  margin-top: 6px\n}\n\n/* main layout */\n.left {\n  grid-column: 1 / span 7;\n}\n\n.right {\n  grid-column: 8 / span 5;\n}\n\n/* tables and lists */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px\n}\n\nth, td {\n  padding: 8px;\n  text-align: right;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03)\n}\n\nth {\n  color: var(--muted);\n  font-weight: 600;\n  font-size: 12px\n}\n\n.priority-list li {\n  background: var(--glass);\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.chip {\n  padding: 6px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  background: rgba(255, 255, 255, 0.03)\n}\n\n/* responsive */\n@media (max-width: 900px) {\n  .metrics {\n    grid-template-columns:repeat(2, 1fr)\n  }\n\n  .left {\n    grid-column: 1 / -1\n  }\n\n  .right {\n    grid-column: 1 / -1\n  }\n\n  .grid {\n    grid-auto-rows: minmax(80px, auto)\n  }\n}\n\n/* small helpers */\n.muted {\n  color: var(--muted);\n  font-size: 13px\n}\n\n.progress {\n  height: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 999px;\n  overflow: hidden\n}\n\n.progress > i {\n  display: block;\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent), #7c3aed)\n}\n\n.green {\n  color: var(--success)\n}\n\n.red {\n  color: var(--danger)\n}\n\n.btn {\n  background: var(--accent);\n  color: #021022;\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  cursor: pointer\n}\n\n.controls {\n  display: flex;\n  gap: 8px;\n  align-items: center\n}\n\n.small {\n  font-size: 12px\n}\n\n.delta {\n  font-size: 12px;\n  margin-inline-start: 6px\n}\n\n/* סטייל לסטריפ קוביות סטטוס */\n.status-strip {\n  display: flex;\n  gap: 1rem;\n  margin: 1rem 0;\n  flex-wrap: nowrap; /* single row, side to side */\n  width: 100%;\n}\n\n.status-box {\n  flex: 1 1 0; /* each box grows equally to fill the row */\n  color: white;\n  padding: 1rem;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n* {\n  box-sizing: border-box;\n  font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial\n}\n\n.container {\n  /*max-width: 1200px;*/\n  margin: 0 auto\n}\n\nheader {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 18px\n}\n\n\n//\n//\n//\n//\n//\n//\n\n\n.card.metric {\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  text-align: right;\n  direction: rtl;\n}\n\n.card.metric .value {\n  font-size: 1.4em;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.subval {\n  font-size: 0.95em;\n  color: #555;\n  margin-top: 4px;\n  color: #fff;\n}\n\n.delta {\n  font-weight: bold;\n  margin-right: 6px;\n}\n\n.delta.up {\n  color: #16a34a; /* ירוק */\n}\n\n.delta.down {\n  color: #dc2626; /* אדום */\n}\n\n.progress {\n  background: #eee;\n  height: 8px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.progress i {\n  display: block;\n  height: 100%;\n  background: linear-gradient(90deg, #22c55e, #15803d);\n}\n\n/* סטייל לסטריפ קוביות סטטוס */\n/* סטייל לסטריפ קוביות סטטוס */\n/* סטייל לסטריפ קוביות סטטוס */\n/* סטייל לסטריפ קוביות סטטוס */\n/* סטייל לסטריפ קוביות סטטוס */\n.status-strip {\n  display: flex;\n  gap: 1rem;\n  //margin: 1rem 0;\n  flex-wrap: nowrap; /* single row, side to side */\n  width: 100%;\n}\n\n.status-box {\n  flex: 1 1 0; /* each box grows equally to fill the row */\n  color: white;\n  padding: 1rem;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.status-box h3 {\n  margin: 0;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.status-box h3 ion-icon {\n  font-size: 1.2rem;\n}\n\n.status-box span {\n  display: block;\n  font-size: 1.6em;\n  margin-top: 5px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
